// 仅在生产环境注册 Service Worker，用于缓存图片资源
const SW_PATH = '/sw.js'
let hasRegistered = false

export const registerServiceWorker = () => {
  if (hasRegistered) return
  hasRegistered = true

  if (!('serviceWorker' in navigator)) return

  const register = () => {
    navigator.serviceWorker.register(SW_PATH).catch((error) => {
      console.warn('[ServiceWorker] 注册失败：', error)
    })
  }

  if (document.readyState === 'complete') {
    register()
    return
  }

  window.addEventListener('load', register, { once: true })
}
